<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="error-template">
                    <h1>Oops!</h1>
                    <h2>404 Not Found</h2>
                    <div class="error-details">
                        Sorry, an error has occured, Requested page not found!
                    </div>
                    <div class="error-actions">
                        <a href="#" @click.prevent="back" class="btn btn-primary btn-lg">
                            <span class="glyphicon glyphicon-home"></span>
                            Back
                        </a>
                        <a href="/" class="btn btn-default btn-lg">
                            <span class="glyphicon glyphicon-envelope"></span>
                            Contact Support
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NotFound',
        data() {
            return {}
        },
        methods: {
            logout() {
                localStorage.clear();
                location.replace('/login');
            },
            back() {
                this.$router.back();
            }
        },
        mounted() {

        }
    }
</script>

<style>
    .error-template {
        padding: 40px 15px;
        text-align: center;
    }

    .error-actions {
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .error-actions .btn {
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Errors/NotFound.vue